export const initialObserverState = { count: 0 };

export function observerReducer(state, event) {
  if (!event) return state;
  if (event.type === 'observerPresent' || event.type === 'observerLeft') {
    return { count: Math.max(0, event.count | 0) };
  }
  return state;
}

export function isObserverVisible(state) {
  return (state?.count || 0) > 0;
}
